import React from "react";

/**
 * Global Modal Component
 */

const Modal = ({ isOpen, onClose, title, children, footer }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6">

        {title && (
          <h3 className="text-lg font-semibold mb-4 text-gray-800">
            {title}
          </h3>
        )}

        <div className="mb-6">
          {children}
        </div>

        {footer && (
          <div className="flex justify-end gap-3">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;